import type { CitationsProps } from "@op/puck-types";

const Citations = (_: CitationsProps) => {
  return null;
};

export default Citations;
